import { tWithKeyAttr as t } from "../../i18nHelper";
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from './consentResponsePage.module.css';
import doctorImage from '../../images/questionnaire_doctor.png'; 

const ConsentResponsePage = () => {
  const [searchParams] = useSearchParams();
  const [title, setTitle] = useState(t('STATUS_REQUEST'));
  const [message, setMessage] = useState(t('PROCESSING_YOUR_REQUEST'));
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const decision = searchParams.get('decision');

    switch (decision) {
      case 'specific':
      case 'global':
        setTitle(t('THANK_YOU_VERY_MUCH'));
        setMessage(t('SUCCESSFUL_CONFIRMATION'));
        setIsError(false);
        break;
      case 'deny':
        setTitle(t('REQUEST_DENIED'));
        setMessage(t('DECISION_TO_DENY_REQUEST'));
        setIsError(false); 
        break;
      case 'processed':
        setTitle(t('ERROR_IN_PROCESSING'));
        setMessage(t('REQUEST_ALREADY_HANDLED'));
        setIsError(true);
        break;
      default:
        setTitle(t('ERROR_MESSAGE'));
        setMessage(t('LINK_INVALID_OR_EXPIRED'));
        setIsError(true);
        break;
    }
  }, [searchParams]);

  const closeWindow = () => {
    window.close();
  };

  return (
    <div className={`layout ${styles.container}`}> 
      <article className={styles.popup}>
        <img src={doctorImage} alt={t('ILLUSTRATION')} className={styles.popup__img} />
        <h2 className={styles.popup__title}>{title}</h2>
        <p className={`${styles.popup__text} ${isError ? styles.popup__text_error : styles.popup__text_success}`}>
          {message}
        </p>
        <button className={styles.popup__button} onClick={closeWindow}>
          {t('CLOSE_WINDOW')}</button>
      </article>
    </div>
  );
};

export default ConsentResponsePage;